module.exports = __webpack_public_path__ + "img/zhulucaopi.3aa8960b.png";